module.exports = __webpack_public_path__ + "media/images/reflections-icon-14d11962742240e319472d12d395f38b.svg";